import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// Enhanced Cyber Grid Background Component
const CyberGrid = () => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX / window.innerWidth, y: e.clientY / window.innerHeight });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0A0E1B] via-[#0D1220] to-[#0A0E1B]" />
      <div className="absolute inset-0 bg-gradient-to-tl from-transparent via-[#15FF75]/[0.02] to-transparent" />
      
      <motion.div 
        className="absolute inset-0"
        style={{
          x: mousePos.x * 20 - 10,
          y: mousePos.y * 20 - 10,
        }}
      >
        <svg className="w-full h-full opacity-[0.03]">
          <defs>
            <pattern id="cyber-grid" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
              <path d="M 60 0 L 0 0 0 60" fill="none" stroke="#15FF75" strokeWidth="0.8" />
              <circle cx="0" cy="0" r="1" fill="#15FF75" opacity="0.8" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#cyber-grid)" />
        </svg>
      </motion.div>
      
      <motion.div 
        className="absolute top-20 left-20 w-[500px] h-[500px]"
        animate={{ 
          x: [0, 100, 0],
          y: [0, -50, 0],
        }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      >
        <div className="w-full h-full rounded-full bg-gradient-to-br from-[#15FF75]/[0.08] to-transparent blur-[100px]" />
      </motion.div>
    </div>
  );
};

export default CyberGrid;